module.exports = __webpack_public_path__ + "img/images/community.jpg?35504d30";